/**
 * Number of replies to initially load per thread.
 */
export const initialReplyCount = 2;

/**
 * Number of replies to initially load per thread in teams-branded experiences
 */
export const teamsBrandedExperiencesInitialReplyCount = 10;

/**
 * Threads with no replies use a timestamp as a placeholder, so that any replies
 * created with getLargeSortKeyForNewReply() or using a server-provided sortKey will
 * greater and therefore visible
 */
type GetSortKeyForCurrentTime = () => string;
export const getSortKeyForCurrentTime: GetSortKeyForCurrentTime = () => `${Date.now()}`.padStart(24, '0');

/**
 * For non-nested pagination, when we load a set of edges but don't want any initially displayed,
 * we need to generate sort keys to represent the first and last cursors in the  empty set of edges
 * initially displayed. Since the displayed edge collection is empty, we can't use the cursors of
 * actual edges as-is, as that would cause that edge to be displayed. Instead, we want a value that
 * represents *just after* the loaded edge, but will still sort before any items that will arrive
 * after it. Because cursors are just strings, we can just append an arbitrary suffix to an existing
 * cursor to get this.
 *
 */
type GetSortKeyImmediatelyAfter = (sortKey: string) => string;
export const getSortKeyImmediatelyAfter: GetSortKeyImmediatelyAfter = (sortKey) => `${sortKey}a`;

/**
 * New replies from publisher use an optimistic sortKey that is a timestamp and
 * padded to ensure they are greater than any server-generated sortKey
 */
type GetLargeSortKeyForNewReply = () => string;
export const getLargeSortKeyForNewReply: GetLargeSortKeyForNewReply = () => `${Date.now()}`.padStart(24, '9');
